<template>
  <PoweredByHeader />
</template>

<script>
import { Components } from '@spectorasoftware/homegauge-vue';

const { PoweredByHeader } = Components;
export default {
  components: { PoweredByHeader },
};
</script>

<style lang="scss" scoped>
.card-header {
  padding: 10px;
  text-align: center;

  > * {
    display: inline-block;
    vertical-align: middle;
  }

  .powered-text {
    color: #333;
    font-size: 1.285rem;
    padding: 0 10px;
  }
}
</style>
